export function removeDiacritics(input: string): string {
  // normalize('NFD') performs "Canonical Decomposition" which splits out
  // any characters that have diacritics baked in, into 2 separate unicode characters.
  // We then remove the diacritics-only characters, leaving only the diacritic-free character.
  // For example: "è" -> "e`" -> "e"

  // https://en.wikipedia.org/wiki/Combining_Diacritical_Marks
  const COMBINING_DIACRITICAL_MARKS_REGEX = /[\u0300-\u036f]/g;

  return input.normalize('NFD').replace(COMBINING_DIACRITICAL_MARKS_REGEX, '');
}
